/** DRF JSONField may arrive as object or stringified JSON. */
export function parseConfigField(raw) {
  if (raw == null) return null;
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  return raw;
}

export function preprocessJson(json) {
  if (json == null || typeof json !== "object") {
    return json;
  }
  const enforceCorrectType = (obj) => {
    if (typeof obj === "number") {
      return obj % 1 === 0 ? obj : parseFloat(obj.toFixed(6));
    }
    if (Array.isArray(obj)) {
      return obj.map((item) => enforceCorrectType(item));
    }
    if (obj && typeof obj === "object") {
      return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [key, enforceCorrectType(value)])
      );
    }
    return obj;
  };

  return enforceCorrectType(json);
}

/**
 * react-json-view submits the typed text as a STRING when an edit is confirmed
 * with the plain check icon (only Ctrl+Enter / the "detected type" icon parse
 * it). A number edited to "100" then fails backend validation
 * ("start_population_size: must be a positive integer"). Returns the editor's
 * `updated_src` with the numeric type restored when the replaced value was a
 * number and the new text is numeric; otherwise `updated_src` unchanged.
 */
export function restoreNumericEdit(updated) {
  const src = updated?.updated_src;
  if (
    typeof updated?.existing_value !== "number" ||
    typeof updated?.new_value !== "string" ||
    updated.new_value.trim() === "" ||
    !Number.isFinite(Number(updated.new_value))
  ) {
    return src;
  }
  const path = [...(updated.namespace || []), updated.name];
  let node = src;
  for (const key of path.slice(0, -1)) node = node?.[key];
  if (node && typeof node === "object") node[path[path.length - 1]] = Number(updated.new_value);
  return src;
}
